// extracted by mini-css-extract-plugin
export var infoBox = "style-module--infoBox--b78d9";
export var infoBox__button = "style-module--infoBox__button--a9cc2";
export var infoBox__buttonContainer = "style-module--infoBox__button-container--9ab36";
export var infoBox__close = "style-module--infoBox__close--b65d9";
export var infoBox__container = "style-module--infoBox__container--b827f";
export var infoBox__main = "style-module--infoBox__main--791ca";